import { ApiLogger } from '../../utils';
import { useMutation } from '@tanstack/react-query';
import uuid from 'react-native-uuid';
import { ToastType } from '../../containers';
import NaturalDisasterConstants from '../../constants/NaturalDisaster';
const useRequestForbearanceMutation = _ref => {
  let {
    forbearanceApiParams,
    onComplete,
    logApiEvent,
    logUserEvent,
    type,
    accessToken
  } = _ref;
  const correlationId = uuid.v4().toString();
  return useMutation({
    mutationFn: requestBody => {
      const config = {
        method: 'post',
        url: `${forbearanceApiParams.baseAWSUrl}cit`,
        headers: {
          'Authorization': `Bearer ${accessToken}`,
          'x-api-key': `${forbearanceApiParams.xApiKey}`,
          'Content-Type': 'application/json',
          'x-correlation-id': correlationId
        },
        data: JSON.stringify(requestBody)
      };
      return ApiLogger(logApiEvent, config);
    },
    onSuccess: async () => {
      onComplete({
        message: NaturalDisasterConstants.SUCCESS_FORBEARANCE_MESSAGE,
        toastType: ToastType.SUCCESS
      });
      logUserEvent({
        type,
        action: `${type}RequestForbearanceSuccess`,
        description: `Request Forbearance Success`
      });
    },
    onError: () => {
      logUserEvent({
        type,
        action: `${type}RequestForbearanceFailed`
      });
      onComplete({
        message: NaturalDisasterConstants.FAILURE_FORBEARANCE_MESSAGE,
        toastType: ToastType.ERROR
      });
    }
  });
};
const useUpdateBorrowerImpactedStatusMutation = _ref2 => {
  let {
    borrowerImpactedApiParams,
    logApiEvent,
    logUserEvent,
    onComplete,
    accessToken
  } = _ref2;
  const correlationId = uuid.v4().toString();
  return useMutation({
    mutationFn: requestBody => {
      const config = {
        method: 'post',
        url: `${borrowerImpactedApiParams.baseAWSUrl}occurrences`,
        headers: {
          'Authorization': `Bearer ${accessToken}`,
          'x-api-key': `${borrowerImpactedApiParams.xApiKey}`,
          'Content-Type': 'application/json',
          'x-correlation-id': correlationId
        },
        data: JSON.stringify(requestBody)
      };
      return ApiLogger(logApiEvent, config);
    },
    onSuccess: async () => {
      logUserEvent({
        type: 'Natural Disaster',
        action: `UpdatedBorrowerImpactedNaturalDisasterStatusSuccess`,
        description: `Updated Borrower Impacted NaturalDisaster Status Success`
      });
      onComplete({
        message: 'Updated Borrower Impact details',
        toastType: ToastType.DEEPLINK
      });
    },
    onError: () => {
      logUserEvent({
        type: 'Natural Disaster',
        action: `UpdatedBorrowerImpactedNaturalDisasterStatusFailed`
      });
    }
  });
};
export { useRequestForbearanceMutation, useUpdateBorrowerImpactedStatusMutation };
//# sourceMappingURL=index.js.map